export default __webpack_public_path__ + "static/media/alert_error.1fc7f69b.svg";